export default {
  engagementQueues(state) {
    return state.engagementQueues;
  },
  engagementQueueSourceFeeders(state) {
    return state.engagementQueueSourceFeeders;
  },
  engagementQueueSourceFeedersForSelect(state) {
    const allowedAccountTypeList = ["1", "2", "8", "6", "9", "11", "24", "15"];
    return state.engagementQueueSourceFeeders
      .filter((queueSourceFeeder) => allowedAccountTypeList.includes(queueSourceFeeder.externalKey))
      .map((queueSourceFeeder) => ({
        id: queueSourceFeeder.value,
        text: queueSourceFeeder.name,
      }));
  },
  engagementQueueRuleSourceFeedersForSelect(state) {
    return state.engagementQueueSourceFeeders
      .map((queueSourceFeeder) => ({
        id: queueSourceFeeder.value,
        text: queueSourceFeeder.name,
        externalKey:queueSourceFeeder.externalKey
      }));
  },
  engagementQueueDetail(state) {
    return state.engagementQueueDetail;
  },
  engagementQueuesForSelect(state) {
    return state.engagementQueues.items
      .map((queue) => ({
        id: queue.id,
        text: queue.queueName,
      }));
  },
};
